import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-metodos-de-pago-continua-posgrado',
  templateUrl: './metodos-de-pago-continua-posgrado.component.html',
  styleUrls: ['./metodos-de-pago-continua-posgrado.component.scss']
})
export class MetodosDePagoContinuaPosgradoComponent implements OnInit {
  @Input() posgrados = false;
  linkPosg="https://www.youtube.com/watch?v=sPbI87k4Wjo&feature=youtu.be";

  @Input() continua = false;
  linkContinua="https://www.youtube.com/watch?v=k20py8_Fkwk";
  constructor() { }

  ngOnInit(): void {
  }

}
